import React, { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import '../../../assets/Style/Datepicker.css';
import moment from 'moment';

const DateSelectRange = ({ defDate, onChange, isDisabled = false, formatIn = "YYYY-MM-DD HH:mm:ss", formatOut = "YYYY-MM-DD HH:mm:ss", ...otherProps }) => {

    const days = ['ორ', 'სა', 'ოთ', 'ხუ', 'პა', 'შა', 'კვ']
    const months = ['იან', 'თებ', 'მარ', 'აპრ', 'მაი', 'ივნ', 'ივლ', 'აგვ', 'სექ', 'ოქტ', 'ნოე', 'დეკ']

    const locale = {
        localize: {
            day: n => days[n],
            month: n => months[n]
        },
        formatLong: {
            date: () => 'mm/dd/yyyy'
        }
    };

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    useEffect(() => {
        if (startDate || endDate) {
            const formattedStartDate = startDate ? moment(startDate).format(formatOut) : "";
            const formattedEndDate = endDate ? moment(endDate).add(1, 'days').format(formatOut) : "";
            onChange(formattedStartDate, formattedEndDate);
        } else {
            onChange("", "");
        }
    }, [startDate, endDate]);

    return (
        <DatePicker
            locale={locale}
            selected={startDate}
            onChange={([start, end]) => {
                setStartDate(start);
                setEndDate(end);
            }}
            startDate={startDate}
            endDate={endDate}
            selectsRange
            dateFormat="d MMM yyyy"
            disabled={isDisabled}
            monthsShown={2}
            onKeyDown={(e) => {
                e.preventDefault();
            }}
            {...otherProps}
        />
    );
};

export default DateSelectRange;
